import { createContext, useContext, } from 'react';
export const ChannelsContext = createContext({
    channels: [],
    groups: [],
});
export const useChannels = () => {
    return useContext(ChannelsContext);
};
